/* eslint-disable */
import * as Types from '../../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type AccountDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AccountDataQuery = { __typename: 'Query', account?: { __typename: 'Account', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null };

export type SessionDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SessionDataQuery = { __typename: 'Query', session?: { __typename: 'Session', id: string, token: string, expires: string, impersonatedBy?: { __typename: 'Admin', id: string, firstName: string, lastName: string } | null } | null };


export const AccountDataDocument = gql`
    query accountData {
  account {
    id
    firstName
    middleName
    lastName
  }
}
    ` as unknown as DocumentNode<AccountDataQuery, AccountDataQueryVariables>;
export const SessionDataDocument = gql`
    query sessionData {
  session {
    id
    token
    expires
    impersonatedBy {
      id
      firstName
      lastName
    }
  }
}
    ` as unknown as DocumentNode<SessionDataQuery, SessionDataQueryVariables>;